"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wishlistLogin = exports.getWishlistProducts = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const wishlistEndpoints = {
    WishlistProducts: {
        client: 'api/wishlist/basic',
    },
    Login: {
        client: 'api/wishlist/login',
    },
};
const getWishlistProducts = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { showOutOfStock }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, wishlistEndpoints.WishlistProducts, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: showOutOfStock ? Object.assign(Object.assign({}, defaultRequestParams), { showOutOfStock }) : defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data.products;
});
exports.getWishlistProducts = getWishlistProducts;
const wishlistLogin = (_a, authenticationConfig_1) => tslib_1.__awaiter(void 0, [_a, authenticationConfig_1], void 0, function* ({ servicesEndpoint, isServer }, authenticationConfig) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, wishlistEndpoints.Login, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: authenticationConfig,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.wishlistLogin = wishlistLogin;
//# sourceMappingURL=wishlist.api.js.map